import React from "react";
import { Head } from "../Component/Head";

export default function Privacy() {
  return (
    <>
      <Head title="Kebijakan Privasi" />
      <div class="container" data-aos="fade-up">
        <div style={{ padding: "20px" }}>
          <h1>Kebijakan Privasi Aplikasi Peduli TBC</h1>
          <p>
            Aplikasi Peduli TBC berkomitmen untuk melindungi privasi Anda.
            Kebijakan privasi ini menjelaskan bagaimana kami mengumpulkan,
            menggunakan, dan melindungi informasi pribadi Anda.
          </p>
          <h2>Data yang Dikumpulkan</h2>
          <ul>
            <li>
              Informasi Pribadi: Nama, alamat, tanggal lahir, dan alamat email.
            </li>
            <li>
              Informasi Kesehatan: Riwayat medis, dan informasi kesehatan
              lainnya yang relevan.
            </li>
            <li>
              Data Lokasi: Lokasi geografis Anda untuk memantau penyebaran TBC.
            </li>
            <li>
              Data Penggunaan: Informasi tentang bagaimana Anda menggunakan
              aplikasi, termasuk halaman yang dikunjungi dan fitur yang
              digunakan.
            </li>
          </ul>
          <h2>Penggunaan Data</h2>
          <p>Data yang dikumpulkan akan digunakan untuk:</p>
          <ul>
            <li>Memantau dan menganalisis penyebaran TBC.</li>
            <li>
              Menyediakan layanan dan dukungan yang lebih baik kepada pengguna.
            </li>
            <li>Meningkatkan fitur dan fungsionalitas aplikasi.</li>
            <li>Memenuhi kewajiban hukum dan peraturan.</li>
          </ul>
          <h2>Perlindungan Data</h2>
          <p>
            Kami mengambil langkah-langkah yang wajar untuk melindungi informasi
            pribadi Anda dari akses, penggunaan, atau pengungkapan yang tidak
            sah. Namun, tidak ada metode transmisi data melalui internet atau
            metode penyimpanan elektronik yang sepenuhnya aman.
          </p>
          <h2>Perubahan Kebijakan Privasi</h2>
          <p>
            Kami dapat memperbarui kebijakan privasi ini dari waktu ke waktu.
            Kami akan memberi tahu Anda tentang perubahan tersebut dengan
            memposting kebijakan privasi yang diperbarui di aplikasi kami.
          </p>
          <h2>Kontak</h2>
          <p>
            Jika Anda memiliki pertanyaan atau kekhawatiran tentang kebijakan
            privasi ini, silakan hubungi kami di sydigital.id@gmail.com.
          </p>
        </div>
      </div>
    </>
  );
}
